export const LOCKED_ACCOUNT_CODE = "ACCOUNT_LOCKED_ACCOUNT";
export const ACCOUNT_INACTIVATED_CODE = "ACCOUNT_INACTIVATED_ACCOUNT";
export const NOT_FOUND_CODE = 404;
export const SUBSCRIPTION_EMPTY_LIST_ERROR_CODE = "SUBSCRIPTION_EMPTY_LIST";
export const EXPORTER_USER_EXPORTER_INACTIVATED_CODE = "EXPORTER_USER_EXPORTER_INACTIVATED";
export const EXPORTER_USER_SUBSCRIPTION_NOT_AVAILABLE_CODE = "EXPORTER_USER_SUBSCRIPTION_NOT_AVAILABLE";
